/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/JourneysPageQuery$parameters.ts';
import type { JourneysPageQuery } from './__generated__/JourneysPageQuery.graphql.ts';

type Queries = {
	journeysPageQueryRef: JourneysPageQuery;
};

type JourneysEntryPointComponent = EntryPointComponent<Queries, {}, {}, {}>;

export const journeysEntryPoint: EntryPoint<JourneysEntryPointComponent, EntryPointRouteParams> =
	createEntryPoint({
		root: JSResourceForInteraction<JourneysEntryPointComponent>(
			/* webpackChunkName: "async-servicedesk-journeys", jiraSpaEntry: "async-servicedesk-journeys" */ './JourneysPage.tsx',
		),
		getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => ({
			queries: {
				journeysPageQueryRef: {
					parameters,
					variables: {
						cloudId: tenantContext.cloudId,
						projectKey: context.match.params.projectKey || '',
						cloudIdAsString: tenantContext.cloudId,
					},
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
				},
			},
			entryPoints: {},
			extraProps: {},
		}),
	});
